module.exports = __webpack_public_path__ + "img/upgradeMember.bc9adb2e.png";